module.exports = __webpack_public_path__ + "static/media/iconAssistant.cc30b1e1.svg";